import { useCallback } from 'react';
import { redirect } from 'redux-first-router';
import { useDispatch } from 'react-redux';
import {
  ROUTE_DISCOVER_INVESTING_IDEAS,
  ROUTE_DISCOVER_INVESTING_IDEAS_MARKET,
} from '@/constants/routes';
import { useMarketOptions } from '@/hooks/discover/useMarketOptions';
import useUser from '@/hooks/useUser';
import type { PrimaryCountryISOElseGlobal } from '@/constants/countries';

// Separate pure function for route logic
export const getMarketRedirectAction = (
  market: PrimaryCountryISOElseGlobal,
  isLoggedIn: boolean
) => {
  // Global page logged out users: `/discover/investing-ideas`
  // Global page logged in users: `/discover/global/investing-ideas`
  const type =
    !isLoggedIn && market === 'global'
      ? ROUTE_DISCOVER_INVESTING_IDEAS
      : ROUTE_DISCOVER_INVESTING_IDEAS_MARKET;

  return redirect({ type, payload: { market } });
};

export const useMarketFilter = ({ route }: { route: string }) => {
  const user = useUser();
  const dispatch = useDispatch();
  const marketOptions = useMarketOptions(true, route);

  const handleMarketChange = useCallback(
    (market: PrimaryCountryISOElseGlobal) => {
      const action = getMarketRedirectAction(market, user.data.loggedIn);
      dispatch(action);
    },
    [dispatch, user.data.loggedIn]
  );

  return { marketOptions, handleMarketChange };
};
